import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface DialogData {
  saveAction: () => Observable<unknown>;
  discardAction: () => Observable<unknown>;
}

export interface DialogResult {
  closeDocument: boolean;
}

@Component({
    selector: 'ldw-document-leave-dialog',
    templateUrl: './document-leave-dialog.component.html',
    styleUrls: ['./document-leave-dialog.component.scss'],
    standalone: false
})
export class DocumentLeaveDialogComponent {
  private dialogRef = inject<MatDialogRef<DocumentLeaveDialogComponent, DialogResult>>(MatDialogRef);
  private data = inject<DialogData>(MAT_DIALOG_DATA);

  cancel() {
    this.dialogRef.close({ closeDocument: false });
  }

  save() {
    this.data.saveAction().subscribe(() => this.dialogRef.close({ closeDocument: true }));
  }

  discard() {
    this.data.discardAction().subscribe(() => this.dialogRef.close({ closeDocument: true }));
  }
}
